











































import { editFactory } from '@/main/pages';

import dayjs from 'dayjs';
import { showAlert } from '@/main/utils/notifications';

import { store } from './store/edit';
import { DOCUMENT_NO_MAXLENGTH, NAME } from './constants';
import { apiProvider as dokladCiselnaRadaProvider } from '../dokladCiselnaRada/api';
import { apiProvider } from './api';
import { editName, START_LOADING, END_LOADING, TABLE_DATA, TABLE_SCHEMA } from '@/main/store/listEditTypes';
export default editFactory(NAME, store).extend({
	computed: {
		documentNumberMaxLengthCmp() {
			this.docNumberMaxLength = this.DokladPfx !== null ? (DOCUMENT_NO_MAXLENGTH - this.DokladPfx.length) : (DOCUMENT_NO_MAXLENGTH - 1);
			return this.docNumberMaxLength;
		},
		isNumberSeriesDisabled() {
			if (this.StartDate && this.isEditMode) {
				return dayjs(dayjs(new Date()).startOf('day').toDate()).isAfter(dayjs(this.StartDate), 'day');
			}
			return this.isViewMode;
		},
		documentNumberPlaceholderTextCmp() {
			return this.LocalizePopisPoli('NS_MAX_DOCUMENT_SFX').replace('<NUM>', `${this.docNumberMaxLength}`);
		},
	},
	methods: {
		async saveClick() {
			const response = await apiProvider.validate(this.edit);
			if (response && response.data.isValid) {
				await this.save();
			} else {
				showAlert({
					message: this.LocalizeChyboveHlasky(response?.data.message),
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: { type: 'error' },
				});
			}
		},
		async onDealerKvpsChange() {
				this.$store.commit(`${this.storeUri}/${START_LOADING}`);
				if (this.DealerKvpsId !== null) {
						const { data: docTypeList } = await dokladCiselnaRadaProvider.getDocumentType(this.DealerKvpsId);
						this.dropdownList.DocumentTypes = docTypeList;
						this.$store.commit(`${this.storeUri}/${END_LOADING}`);
					}
		},
		onDokladPfxValueUpdate(): void {
			this.DokladNr = null;
		},
	},
});
